import { render, staticRenderFns } from "./PoiForm.vue?vue&type=template&id=7c068d62"
import script from "./PoiForm.vue?vue&type=script&lang=js"
export * from "./PoiForm.vue?vue&type=script&lang=js"
import style0 from "./PoiForm.vue?vue&type=style&index=0&id=7c068d62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports